<template>
  <div>
    <div v-if="photos">
      <div class="is-size-4 mb-5" @click="toggle()" style="cursor:pointer">
        {{ this.photoSet }} Photos
        <span class="is-size-7 has-text-grey">(Click to toggle)</span>
      </div>

      <div v-for="(photo, index) in photos" :key="index">
        <img
          :src="getUrl(photo)"
          style="max-width:600px;max-height:500px;cursor:pointer"
          @click="clickHandler(photo)"
        />
        <div class="mb-2">{{ photo.photo_reference }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CityPhotos",
  props: {
    code: {
      required: true,
      //type: Object,
    },
  },
  data() {
    return {
      photos: null,
      googlePhotos: null,
      savedPhotos: null,
      photoSet: null,
    };
  },
  methods: {
    //Toggle between Google Photos and photos saved to MongoDB
    async toggle() {
      await this.getGooglePhotos();
      await this.getSavedPhotos();

      if (this.photoSet == "Google") {
        this.photos = this.savedPhotos;
        this.photoSet = "Saved";
      } else {
        this.photos = this.googlePhotos;
        this.photoSet = "Google";
      }
    },
    async getGooglePhotos() {
      let result = await this.$app.huddleLabsServerCall(
        "resources/city-photos/google-list",
        {
          code: this.code,
        }
      );

      this.googlePhotos = result;
    },
    //If currently showing saved photos, clicking on a photo will save photo to database. If displaying Saved photos, clicking on it will delete
    clickHandler(photo) {
      if (this.photoSet == "Saved") {
        this.deletePhoto(photo._id);
      } else {
        this.savePhoto(photo.photo_reference);
      }
    },
    async getSavedPhotos() {
      let result = await this.$app.huddleLabsServerCall(
        "resources/city-photos/list",
        {
          code: this.code,
        }
      );

      this.savedPhotos = result;
    },
    async savePhoto(ref) {
      let result = await this.$app.huddleLabsServerCall(
        "resources/city-photos/save",
        {
          photo_reference: ref,
          code: this.code,
        }
      );
    },
    async deletePhoto(id) {
      let result = await this.$app.huddleLabsServerCall(
        "resources/city-photos/delete",
        {
          id: id,
        }
      );
    },
    getUrl(photo) {
      return (
        "https://maps.googleapis.com/maps/api/place/photo?maxwidth=800&photo_reference=" +
        photo.photo_reference +
        "&key=" + this.$appConfig.googleKey
      );
    },
  },
  async mounted() {
    await this.getGooglePhotos();
    await this.getSavedPhotos();

    this.photos = this.googlePhotos;
    this.photoSet = "Google";
  },
};
</script>

<style></style>
